
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.937 3.061h-2.904A1.06 1.06 0 0012.973 2H7.024a1.06 1.06 0 00-1.06 1.061H3.06a1.06 1.06 0 100 2.123h13.876a1.062 1.062 0 100-2.123zM3.652 7.336l.212 9.382a2.3 2.3 0 002.301 2.253h7.668c.627 0 1.195-.25 1.61-.657a2.28 2.28 0 00.69-1.596l.215-9.382H3.652z","fill":"#7D7D7D","fill-rule":"evenodd"}})])
          )
        }
      }
    